var _rect, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 16,
    fill: "url(#paint0_linear_106_922)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0627,
    y: 25.8741,
    width: 4.92132,
    height: 3.44492,
    rx: 1.72246,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6377,
    y: 18,
    width: 2.36223,
    height: 19.1931,
    rx: 1.18112,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3512 19.0196V22.1314H35.6122C36.5002 22.1314 37.2271 22.8583 37.2271 23.7463C37.2271 24.6342 36.5002 25.3611 35.6122 25.3611H29.3512V30.1016H35.6122C36.5002 30.1016 37.2271 30.8284 37.2271 31.7164C37.2271 32.6044 36.5002 33.3313 35.6122 33.3313H29.3512V36.3606C29.3512 36.9224 28.8915 37.3802 28.3316 37.3802H27.149C26.5871 37.3802 26.1294 36.9205 26.1294 36.3606V19.0196C26.1294 18.4577 26.5891 18 27.149 18H28.3316C28.8935 18 29.3512 18.4597 29.3512 19.0196ZM26.1097 19.8211H23.6383C19.3046 19.8192 17.1848 21.7444 16.6524 26.1607V29.3904H16.6917C17.1121 33.7615 19.6818 35.73 23.88 35.73H26.1097V19.8211ZM25.21 23.4732V32.0759H23.9311V23.4732H25.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_922",
    x1: 27.5,
    y1: 0,
    x2: 27.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5856A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8557A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.915e763917a92f1ca71690371255e12c.svg";
export { ForwardRef as ReactComponent };